import React, { useState, useEffect } from 'react';
import Switch from "react-switch";
import { Button, Col, Row } from "reactstrap";

export default function LabelSwitch(props) {
   const [value, setValue] = useState(true);

   useEffect(() => {
      setValue(props.value ?? true)
   }, [props.value]);

   function onChange(checked) {
      props.onChangeCallback(
         checked ? true : false
      );
      setValue(checked);
   }

   function onClick() {
      props.onButtonClick();
   }

   return (
      <Row className="d-flex align-items-center justify-content-center">
         <Col className="d-flex align-items-center width225px">
            {props.displayName
               ? <div className="filter-definition-caption mx-1 p-0">{props.displayName}</div>
               : null}
            <Switch onChange={(checked) => onChange(checked)} checked={value || false} className="mx-1" />
         </Col>
         <Col>
            <Button className="shredButton mx-1" onClick={() => onClick()} disabled={props.disabled} >
               {props.buttonLabel}
            </Button>
         </Col>
      </Row>
   );
}